import React, { useContext, useEffect, useState } from 'react';
import { Typography, Checkbox, Button, Tooltip } from '@material-ui/core';
import Cookies from 'universal-cookie';
import md5 from 'md5';
import moment from 'moment';
import 'moment/locale/pt-br';

//components
import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import CardPedido from '../../../../../../../../../util/cardPedido/.mixins/index';
import SearchPedido from '../../../../../../../../../util/searchPedido/.mixins/index';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import ModalTable from '../../../../../../../../../util/modalDinamica/childrens/modalTable/.mixins/modalTable';
import MultiSelectModal from '../../../../../../../../../util/modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal';
import DialogCalendar from '../../../../../../../../../util/calendar/.mixins';
import ModalAgendPenAvisoRecusa from '../../agendamentoPendentes/childrens/modalAgendPenAvisoRecusa/.mixins/index';
import { AuthContext } from '../../../../../../../../../../contexts/AuthContext';

import ModalConfirmaRecusa from '../childrens/modal';

//controllers
import { getPedidosConfirmados, getPedidosAgendados } from '../../../../../../../../../../controllers/agendamentosRespondidos';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default function AgendamentosConfirmados(props) {
  const { user } = useContext(AuthContext);

  //CardPedido
  const {
    fornecedor,
    firstLoad,
    itensPedidoConfirmados,
    itensPedidoConfirmadosSelected,
    isOpenModalConfirmaRecusa,
    escolhaMotivoRecusaAgendamentoPendentes,
    opcoesFilial
  } = props.state;

  const {
    childAlerta,
    setState,
    loadMotivos,
  } = props;

  const [pedidos, setPedidos] = useState([]);
  const bt_component = [
    {
      label: 'VER DETALHES DO PEDIDO',
      handler: (props) => {
        setIsOpenModalTable(!isOpenModalTable);
        setIsLoading(!isLoading);
        loadDataModal(props);
        setState({
          itensPedidoConfirmadosSelected: [],
          escolhaMotivoRecusaAgendamentoPendentes: "",
          dataSugestaoEntrega: new Date(),
        })
      },
    },
  ];

  //Paginação
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [totalRows, setTotalRows] = useState(0);

  //SearchPedido
  const [searchFieldExternal, setSearchFieldExternal] = useState('');
  const [dtInitial, setDtInitial] = useState(moment().toDate());
  const [dtEnd, setDtEnd] = useState(moment().add(30, 'days').toDate());

  //ModalTable
  const [isOpenModalTable, setIsOpenModalTable] = useState(false);
  const [isAtivaFilter, setIsAtivaFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const colunasModalTable = [
    {
      name: 'id_item',
      options: {
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'productId',
      label: 'ID Prod',
    },
    {
      name: 'numericCode',
      label: 'Cód num',
    },
    {
      name: 'alphaId',
      label: 'Alfa',
    },
    {
      name: 'productName',
      label: 'Nome do Produto',
    },
    {
      name: 'colorAbbreviation',
      label: 'Cor',
    },
    {
      name: 'scheduleQuantity',
      label: 'Qtd',
    },
    {
      name: 'sciaStatusDescription',
      label: 'Status',
    },
    {
      name: 'deliveryDate',
      options: {
        display: false,
        viewColumns: false,
      },
    },

  ];
  const [descriptionsModalTable, setDescriptionsModalTable] = useState({
    nr_pedido: 0,
    dt_agendamento: '',
    ds_filial: '',
  });

  const [escolhaFilial, setEscolhaFilial] = useState({ id: 0, name: "Selecione uma filial" });

  //OpcoesBusca
  const [searchField, setSearchField] = useState('');
  const [colunasOpcoesDeBusca, setColunasOpcoesDeBusca] = useState([
    {
      key: 'Número do Pedido',
      value: false,
    },
    {
      key: 'ID Produto',
      value: false,
    },
    {
      key: 'Código Numérico',
      value: false,
    },
    {
      key: 'Nome do Produto',
      value: false,
    },
  ]);

  //OpcoesBuscaTags
  const [colunasFilterTags, setColunasFilterTags] = useState([
    {
      key: 'Número do Pedido',
      value: '',
      origemValue: ""
    },
    {
      key: 'ID Produto',
      value: '',
      origemValue: ""
    },
    {
      key: 'Código Numérico',
      value: '',
      origemValue: ""
    },
    {
      key: 'Nome do Produto',
      value: '',
      origemValue: ""
    },
    {
      key: "Data de agendamento",
      value: "",
      origemValue: ""
    },
    {
      key: 'Filial',
      value: '',
      origemValue: ""
    },
  ]);

  const dateFormat = (date) => {
    return moment(date).format('DD/MM/YYYY');
  };

  const handlerChangeDateInitial = async (value) => {
    setDtInitial(value);
    let newColunasFilterTags = colunasFilterTags;
    newColunasFilterTags[4].value = `${dateFormat(value)} - ${dateFormat(dtEnd)}`;
    setColunasFilterTags(newColunasFilterTags);
  };

  const handlerChangeDateEnd = async (value) => {
    setDtEnd(value);
    let newColunasFilterTags = colunasFilterTags;
    newColunasFilterTags[4].value = `${dateFormat(dtInitial)} - ${dateFormat(value)}`;
    setColunasFilterTags(newColunasFilterTags);
  };

  //SearchPedido - Functions()
  const handleChangeSearchFieldPedido = (event) => {
    setSearchFieldExternal(event.target.value);
  };

  const handleClickSearchField = async () => {
    await setState({ firstLoad: true })

    getPedidos({
      linha_inicial: 0,
      qtd_registro: rowsPerPage,
      tipo_load: 'searchField'
    });
    await setState({ firstLoad: false })
  };

  //Paginação - Functions()
  const onChangePage = async (pageFrom) => {
    getPedidos({
      linha_inicial: pageFrom,
      qtd_registro: rowsPerPage,
      tipo_load: 'onchange'
    });
  };

  const handlerChangeSearchFilterTag = async (i, coluns) => {
    let newColunasFilterTags = colunasFilterTags;

    const nameObject = coluns[i].key;
    const indexObject = colunasFilterTags.map(e => e.key).indexOf(nameObject);

    if (indexObject < 0) return;

    if (coluns[i].value) {
      newColunasFilterTags[indexObject].value = searchField;
    } else {
      newColunasFilterTags[indexObject].value = "";
    }
    // sem essa conversão não renderiza o array tags
    await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
  };

  //OpcoesBusca - Functions()
  const handlerClickCheckbox = async (i) => {
    const coluns = colunasOpcoesDeBusca.map((coluna, index) => {
      return index === i ? { ...coluna, value: !coluna.value } : coluna;
    });
    await setColunasOpcoesDeBusca(coluns);
    await handlerChangeSearchFilterTag(i, coluns);
  };

  const handlerSelectCheckboxAgendamentoModalRecusaConfirmado = async (params) => {
    //TODO Futuramente Refatorar essa parte e ajustar para comportar a correção do Bug 
    let newArray = itensPedidoConfirmadosSelected;

    const index = newArray
      .map(e => md5(e[2].toString() + e[9].toString()))
      .indexOf(md5(params[2].toString() + params[9].toString()));

    if (index > -1) {
      newArray.splice(index, 1);
    } else {
      newArray.push(params);
    }
    await setState({ itensPedidoConfirmadosSelected: newArray });

    let newListItens = itensPedidoConfirmados;
    const indexFullItensList = newListItens.map(e => e["id_item"]).indexOf(params[1]);
    newListItens[indexFullItensList]["CHECK"] = !newListItens[indexFullItensList]["CHECK"];
    await setState({ itensPedidoConfirmados: newListItens });
  };

  const handleChangeSearchFieldOpcoesBusca = (event) => {
    event.persist();
    setSearchField(event.target.value);
  };

  //OpcoesBuscaPopover - Functions()
  const handlerCleanFilters = async () => {
    await setState({ firstLoad: true })
    setSearchField('');
    setSearchFieldExternal('');
    setDtInitial(moment().toDate());
    setDtEnd(moment().add(30, 'days').toDate());
    setEscolhaFilial({ id: 0, name: "Selecione uma filial" });

    setColunasOpcoesDeBusca(
      colunasOpcoesDeBusca.map((coluna) => {
        coluna.value = false;
        return coluna;
      })
    );

    setColunasFilterTags(
      colunasFilterTags.map((coluna) => {
        coluna.value = '';
        return coluna;
      })
    );
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'cleanFilters' });
    await setState({ firstLoad: false })
  };
  const handlerAplicarFilters = async () => {
    await setState({ firstLoad: true })
    const index = colunasOpcoesDeBusca.findIndex(
      (coluna, index) => coluna.value === true && colunasFilterTags[index].value === ''
    );

    setColunasFilterTags(
      colunasFilterTags.map((coluna, i) => {
        return i === index ? { ...coluna, value: searchField } : coluna;
      })
    );

    setSearchField('');
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'applyFilters' });
    await setState({ firstLoad: false })
  };

  //OpcoesBuscaTags - Functions()
  const handlerClearFilterTag = async (i) => {
    await setColunasFilterTags(
      colunasFilterTags.map((coluna, index) => {
        return index === i ? { ...coluna, value: '' } : coluna;
      }));

    await setColunasOpcoesDeBusca(
      colunasOpcoesDeBusca.map((coluna, index) => {
        return index === i ? { ...coluna, value: false } : coluna;
      }));

    await setIsAtivaFilter(true);
  };

  //ModalTable - Functions()
  const handleDialogModalTable = () => {
    setIsOpenModalTable(!isOpenModalTable);
  };

  const loadDataModal = (props) => {
    setIsLoading(true);
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    const { nr_pedido, dt_agendamento, ds_filial, cd_filial, element } = props;
    const filters = {
      purchaseOrderId: element.purchaseOrderId,
      branchId: element.branchDeliveryId,
      initialScheduleDate: element.scheduleDate,
      finalScheduleDate: element.scheduleDate,
      personId: fornecedor,
      statusSciaIs: 'C',
    };

    setDescriptionsModalTable({
      ...descriptionsModalTable,
      nr_pedido: nr_pedido,
      dt_agendamento,
      ds_filial,
      cd_filial,
    });

    getPedidosConfirmados(token, filters)
      .then(async (response) => {
        if (response.res.statusCode === 200) {
          setIsLoading(false);
          const responseItens = JSON.parse(response.body);
          let contIdItem = 0
          const arrayItens = responseItens.map((item) => {
            contIdItem++
            item.STATUS = 'Confirmado'
            item.id_item = contIdItem
            item.CHECK = false
            return {
              ...item
            };
          });
          await setState({ itensPedidoConfirmados: arrayItens })
        } else if (response.res.statusCode === 404) {
          const responseItens = JSON.parse(response.body);
          props.childAlerta.current.retorno(responseItens.message, 'warning');
        } else {
          props.childAlerta.current.retorno('Não foi possível efetuar essa consulta!', 'error');
        }
      })
      .catch((error) => {
        setIsError(true);
        setError(error);
        console.error(error);
        props.childAlerta.current.retorno(error.message, 'error');
      }).finally(async () => {
        await setState({ isLoading: false });
      })
  };

  const parseDate = (date) => {
    const [newDate] = date.split(' ');
    const finalDate = newDate.split('/').reverse().join('-');
    return finalDate;
  };

  const isInt = (value) => {
    return !isNaN(value) &&
      parseInt(Number(value)) == value &&
      !isNaN(parseInt(value, 10));
  };

  const getPedidos = async ({ linha_inicial, qtd_registro, tipo_load }) => {
    await setState({ isLoading: true })
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    let nr_pc = null;
    let id_prod = null;
    let cd_num = null;
    let nm_prod = null;
    let cd_fil = "";

    const arrayColNrPcTag = colunasFilterTags
      .filter(element => (
        element.key === "Número do Pedido" &&
        element.value !== element.origemValue
      ));

    const arrayColNrProdTag = colunasFilterTags
      .filter(element => (
        element.key === "ID Produto" &&
        element.value !== element.origemValue
      ));

    const arrayColCdNumTag = colunasFilterTags
      .filter(element => (
        element.key === "Código Numérico" &&
        element.value !== element.origemValue
      ));

    const arrayColDsProdTag = colunasFilterTags
      .filter(element => (
        element.key === "Nome do Produto" &&
        element.value !== element.origemValue
      ));

    const arrayColFilialTag = colunasFilterTags
      .filter(element => (
        element.key === "Filial" &&
        element.value !== element.origemValue
      ));

    const arrayDatasTags = colunasFilterTags
      .filter(element => (
        element.key === "Data de agendamento" &&
        element.value !== element.origemValue
      ));

    if (arrayColNrPcTag.length > 0) {
      nr_pc = parseInt(arrayColNrPcTag[0].value);

      if (!isInt(nr_pc)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColNrProdTag.length > 0) {
      id_prod = parseInt(arrayColNrProdTag[0].value);

      if (!isInt(id_prod)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColCdNumTag.length > 0) {
      cd_num = parseInt(arrayColCdNumTag[0].value);

      if (!isInt(cd_num)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColDsProdTag.length > 0 && !isInt(searchField)) {
      nm_prod = arrayColDsProdTag[0].value;
    }

    if (arrayColFilialTag.length > 0) {
      cd_fil = arrayColFilialTag[0].value;
    }

    if (tipo_load == "searchField") {
      if (isInt(searchFieldExternal)) {
        nr_pc = searchFieldExternal;
      } else {
        nm_prod = searchFieldExternal;
      }
    } else if (tipo_load == "applyFilters") {
      if (
        arrayColNrPcTag.length == 0 &&
        arrayColNrProdTag.length == 0 &&
        arrayColCdNumTag.length == 0 &&
        arrayColDsProdTag.length == 0 &&
        searchField != ""
      ) {
        setSearchField("");
      }
    }

    let dtInitialp, dtEndp = null;
    if (arrayDatasTags.length > 0) {
      dtInitialp = moment(dtInitial).format("DD/MM/YYYY");
      dtEndp = moment(dtEnd).format("DD/MM/YYYY");
    }

    let filters = {
      initialRow: linha_inicial,
      nextRows: qtd_registro,
      personId: fornecedor,
      statusSciaIs: 'C',
    };

    if (nr_pc != null) {
      filters = { ...filters, purchaseOrderId: nr_pc };
    }
    if (id_prod != null) {
      filters = { ...filters, productId: id_prod };
    }
    if (cd_num != null) {
      filters = { ...filters, numericCode: cd_num };
    }
    if (nm_prod != null) {
      filters = { ...filters, productName: nm_prod };
    }
    if (dtInitialp != null) {
      filters = { ...filters, initialScheduleDate: dtInitialp };
    }
    if (dtEndp != null) {
      filters = { ...filters, finalScheduleDate: dtEndp };
    }
    if (cd_fil !== "") {
      filters = {
        ...filters,
        branchId: (cd_fil === "") ? null : escolhaFilial.id
      };
    }

    getPedidosAgendados(token, filters)
      .then(async (response) => {
        if (response.res.statusCode === 200) {
          const responseConfirmados = JSON.parse(response.body);
          setTotalRows(responseConfirmados.length > 0 ? responseConfirmados[0].totalRows : 0);
          responseConfirmados.map((pedido) => {
            return {
              ...pedido,
            };
          });

          setPedidos(responseConfirmados);
        } else if (response.res.statusCode === 404) {
          const responseConfirmados = JSON.parse(response.body);
          props.childAlerta.current.retorno(responseConfirmados.message, 'warning');
        } else {
          props.childAlerta.current.retorno('Não foi possível efetuar essa consulta!', 'error');
        }
      })
      .catch((error) => {
        setIsError(true);
        setError(error);
        console.error(error);
        props.childAlerta.current.retorno(error.message, 'error');
      }).finally(async () => {
        await setState({ isLoading: false });
      })
  };

  const loadInit = async () => {
    await handlerCleanFilters();
    await getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'firstLoad' });
  };

  useEffect(() => {
    loadInit();
  }, [fornecedor]);

  useEffect(() => {
    if (isAtivaFilter) {
      getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'rowsPerPage' });
    }
  }, [rowsPerPage]);

  useEffect(() => {
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'isAtivaFilter' });
    setIsAtivaFilter(false);
  }, [isAtivaFilter, setIsAtivaFilter]);

  const setIsOpenModalConfirmaRecusa = async () => {
    await setState({
      isOpenModalConfirmaRecusa: !isOpenModalConfirmaRecusa,
    });
    handleDialogModalTable();
  };

  const actionButton = async () => {
    await setState({
      openModalMotivoRecusaAgendamentoPendentes: !props.state.openModalMotivoRecusaAgendamentoPendentes,
      isOpenModalConfirmaRecusa: false,
    });
    loadMotivos();
  };

  const handleModalMotivoRecusa = async () => {
    await setState({
      openModalMotivoRecusaAgendamentoPendentes: !props.state.openModalMotivoRecusaAgendamentoPendentes,
    });
    handleDialogModalTable();
  };

  const actionButtonModalMotivoRecusa = async () => {
    if (escolhaMotivoRecusaAgendamentoPendentes !== "") {
      await setState({
        openModalMotivoRecusaAgendamentoPendentes: false,
        openDialogCalendarAgendamentoPendentes: !props.state.openDialogCalendarAgendamentoPendentes,
      });
    } else {
      childAlerta.current.retorno(`Por favor selecione um motivo`, 'warning');
    }
  };

  const handleModalRecusaCloseAgendamentoPendentes = async () => {
    await setState({
      openModalRecusaAgendamento: !props.state.openModalRecusaAgendamento,
    });
  }

  const handleModalCalendar = async () => {
    await setState({
      openDialogCalendarAgendamentoPendentes: !props.state.openDialogCalendarAgendamentoPendentes,
    });
    actionButton();
  }
  const actionButtonModalCalendar = async () => {
    await setState({
      openDialogCalendarAgendamentoPendentes: !props.state.openDialogCalendarAgendamentoPendentes,
    });
    handleModalMotivoRecusaConfirmAgendamentoPendentes();
  };

  const handleModalMotivoRecusaConfirmAgendamentoPendentes = async (event) => {
    await setState({
      isLoading: true,
      firstLoad: true,
    });

    if (itensPedidoConfirmadosSelected.length > 0) {
      let checkResult = true;
      const orders = [];
      let checkRequest = null;
      itensPedidoConfirmadosSelected.every(async (element) => {
        orders.push({
          cdFil: descriptionsModalTable.cd_filial,
          nrPc: descriptionsModalTable.nr_pedido,
          IdProd: element[2],
          dtEntrega: element[9].split(' ')[0],
          dtAgenda: descriptionsModalTable.dt_agendamento,
          inStatus: "RA",
          idMotivoRecusa: escolhaMotivoRecusaAgendamentoPendentes,
          dtAgeSugFornec: props.getDataSugestaoEntregaAgendamentoConfirmado(),
        });
      });

      checkRequest = await props.loadConfirmRefuseByList(orders);

      if (!checkRequest) {
        checkResult = checkRequest;
        return;
      }

    } else {
      const orders = [];
      orders.push({
        cdFil: descriptionsModalTable.cd_filial,
        nrPc: descriptionsModalTable.nr_pedido,
        IdProd: null,
        dtAgenda: descriptionsModalTable.dt_agendamento,
        inStatus: "R",
        idMotivoRecusa: escolhaMotivoRecusaAgendamentoPendentes,
        dtAgeSugFornec: props.getDataSugestaoEntregaAgendamentoConfirmado(),
      });
      await props.loadConfirmRefuseByList(orders);
    }

    await setState({
      isLoading: false,
      escolhaMotivoRecusaAgendamentoPendentes: "",
      firstLoad: false,
    });
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage });
    handleModalRecusaCloseAgendamentoPendentes();
  };

  const calculateDateDiferenceDays = (begin, end) => {
    const diff = end.diff(begin);
    const days = moment.duration(diff).asDays();
    return days;
  };

  const ColunasModalTable = () => {
    const diffDays = calculateDateDiferenceDays(moment(), moment(descriptionsModalTable.dt_agendamento, "DD/MM/YYYY"));
    const collumnsArray = colunasModalTable;
    if (diffDays > 0) {
      collumnsArray.splice(0, 0, {
        label: 'Selecionar',
        name: 'CHECK',
        options: {
          display: !!user.permissions["gerenciar-pedidos.recusa-confirmacao"],
          customBodyRender: (value, dataIndex, rowIndex) => {
            return (
              <Checkbox
                checked={value}
                onChange={() => {
                  handlerSelectCheckboxAgendamentoModalRecusaConfirmado(dataIndex.rowData)
                }}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            )
          }
        },
      });
    }
    return collumnsArray;
  }


  const FooterModal = (params) => {
    const lengthItensPedidoConfirmadosSelected = itensPedidoConfirmadosSelected.length;
    const lengthItensPedidoConfirmados = itensPedidoConfirmados.length;
    const diffDays = calculateDateDiferenceDays(moment(), moment(descriptionsModalTable.dt_agendamento, "DD/MM/YYYY"));
    const toolTipText = "Não é possivel sugerir uma nova data de entrega no mesmo dia ou posterior à entrega.";
    const checkStatusButton = diffDays <= 0;
    return (
      <Tooltip arrow
        placement={"top"}
        title={checkStatusButton ? toolTipText : ""}>
        <div className={classes.modalFooter} align="center">
          <Button
            variant="contained"
            color="primary"
            disabled={checkStatusButton}
            onClick={() => {
              handleDialogModalTable();
              setIsOpenModalConfirmaRecusa();
            }}
          >
            {lengthItensPedidoConfirmadosSelected !== 0 ?
              `SUGERIR NOVA DATA DE ENTREGA PARA ${lengthItensPedidoConfirmadosSelected} ITEM` :
              `SUGERIR NOVA DATA DE ENTREGA PARA TODOS OS ITENS (${lengthItensPedidoConfirmados})`
            }
          </Button>
        </div>
      </Tooltip>
    )
  }

  const handlerEscolhaFilialSetTag = async (value) => {
    let newColunasFilterTags = colunasFilterTags;

    const indexObject = colunasFilterTags
      .map(e => e.key)
      .indexOf("Filial");
    if (indexObject < 0) return;

    if (value.id > 0)
      newColunasFilterTags[indexObject].value = value.id;
    else
      newColunasFilterTags[indexObject].value = "";

    await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
  };

  const handlerChangeEscolhaFilial = async (value) => {
    await setEscolhaFilial(value);
    await handlerEscolhaFilialSetTag(value);
  };

  const classes = useStyles();
  return (
    <>
      <SearchPedido
        searchField={searchFieldExternal}
        searchStatus={colunasOpcoesDeBusca[0].value}
        handleChangeSearchFieldPedido={handleChangeSearchFieldPedido}
        handleClickSearchField={handleClickSearchField}
      />

      <div className={classes.contentMiddle}>
        <OpcoesBuscaPopoverAllFilter
          searchField={searchField}
          dtInitial={dtInitial}
          dtEnd={dtEnd}
          escolhaData={"Data agendamento"}
          isColunasMultiple={true}
          isFixed={true}
          opcoesFilial={opcoesFilial}
          escolhaFilial={escolhaFilial}
          buttonVariant={'text'}

          colunas={colunasOpcoesDeBusca}
          colunasFilterTags={colunasFilterTags}

          handlerClickCheckbox={handlerClickCheckbox}
          handleChangeSearchFieldPedido={handleChangeSearchFieldOpcoesBusca}

          handlerCleanFilters={handlerCleanFilters}
          handlerAplicarFilters={handlerAplicarFilters}

          handlerClearFilterTag={handlerClearFilterTag}

          handlerChangeDateInitial={handlerChangeDateInitial}
          handlerChangeDateEnd={handlerChangeDateEnd}
          handlerChangeEscolhaFilial={handlerChangeEscolhaFilial}

        />

        <Typography>
          Total de {totalRows}
          {totalRows === 1 ? ' agendamento confirmado' : ' agendamentos confirmados'}
        </Typography>
      </div>

      {pedidos.map((pedido, index) => (
        <div className={classes.cardPedido} key={index}>
          <CardPedido
            className={classes.cardPedido}
            nr_pedido={pedido.purchaseOrderId}
            cd_filial={pedido.branchId}
            dt_agendamento={pedido.scheduleDate}
            ds_filial={`${pedido.branchDeliveryId} - ${pedido.branchName}`}
            ds_msg=''
            bt_component={bt_component}
            element={pedido}
          />
        </div>
      ))}

      <ModalTable
        state={{
          isLoading,
          isOpenModalTable,
          descriptionsModalTable,
          columns: ColunasModalTable(),
          itensTable: itensPedidoConfirmados,
          isError,
          error,
          FooterModal: user.permissions["gerenciar-pedidos.recusa-confirmacao"] && FooterModal,
        }}
        handleDialogModalTable={handleDialogModalTable}
      />

      <Paginacao
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        rowsPerPageOptions={rowsPerPageOptions}
        onChangePage={onChangePage}
        firstLoad={firstLoad}
        setRowsPerPage={setRowsPerPage}
      />
      <ModalConfirmaRecusa
        isModalOpen={isOpenModalConfirmaRecusa}
        handleDialogModal={setIsOpenModalConfirmaRecusa}
        actionButton={actionButton}
      />

      <MultiSelectModal
        checkedId={escolhaMotivoRecusaAgendamentoPendentes}
        isModalOpen={props.state.openModalMotivoRecusaAgendamentoPendentes}
        headerModal={{
          title: "POR QUAL RAZÃO VOCÊ NÃO CONSEGUIRÁ REALIZAR A ENTREGA DO PRODUTO NA DATA PROPOSTA?",
          subtitle: "Lembre-se que você deverá, posteriormente, confirmar o agendamento desses pedidos."
        }}
        btComponent={{ label: "SELECIONAR" }}
        buttonType={'radio'}
        itensModal={props.state.opcoesMotivosRecusa}
        setIdOnChange={props.handleModalMotivoRecusaChangeAgendamentoPendentes}
        getIdOnClick={actionButtonModalMotivoRecusa}
        handleDialogModal={handleModalMotivoRecusa}
      />

      <DialogCalendar
        popupLabel={"SUGESTÃO DE NOVA DATA DE ENTREGA"}
        value={props.getDataSugestaoEntregaAgendamentoConfirmado()}
        openDialogCalendar={props.state.openDialogCalendarAgendamentoPendentes}
        handlerChangeDate={props.handlerOnChangeDataSugestaoEntregaAgendamentoPendetes}
        handlerOpenDataSugestao={handleModalCalendar}
        handlerConfirmarDataSugestao={actionButtonModalCalendar}
        minDate={moment().add(1, 'days').format('MM-DD-YYYY')}
      />

      <ModalAgendPenAvisoRecusa
        open={props.state.openModalRecusaAgendamento}
        handleClose={handleModalRecusaCloseAgendamentoPendentes}
      />

    </>
  );
}
